// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `    .documentos p{margin-bottom: 0px;}
    .main section{margin-top: 50px;}


/* -----------------------------------------------------------------------------
// LISTADO DE DOCUMENTOS EXISTENTES
// ----------------------------------------------------------------------------- */
    .documentos .listado-documentos{
        width: 750px;
        gap: 15px;
    }

    .documentos .listado-documentos .documento{
        border: 1px solid #2A8C4A;
        border-left: 12px solid #2A8C4A;
        border-radius: 15px;
        padding: 12px 30px 12px 20px;
    }

    .documentos .listado-documentos .iconos{ gap: 15px; }
    .documentos .listado-documentos svg{ font-size: 18px; }


/* -----------------------------------------------------------------------------
// AREA verde + BOTÓN PARA SUBIR DOCUMENTOS
// ----------------------------------------------------------------------------- */
    .documentos .subir-documento{ width: calc(100% - 800px); }

    .area-verde {
    height: 150px;
    max-width: 350px;
    background-color: #c8e5b8;
    border: 2px dashed #2A8C4A;
    border-radius: 10px;
    justify-content: center;
    margin: 0 auto;
    text-align: center;
  }
  
  .area-verde p { margin: 0px 20px; }
  
  .documentos .subir-documento button {
    display: block;
    margin: 20px auto;
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/user/css/Documentos.css"],"names":[],"mappings":"IAAI,cAAc,kBAAkB,CAAC;IACjC,cAAc,gBAAgB,CAAC;;;AAGnC;;kFAEkF;IAC9E;QACI,YAAY;QACZ,SAAS;IACb;;IAEA;QACI,yBAAyB;QACzB,+BAA+B;QAC/B,mBAAmB;QACnB,4BAA4B;IAChC;;IAEA,yCAAyC,SAAS,EAAE;IACpD,qCAAqC,eAAe,EAAE;;;AAG1D;;kFAEkF;IAC9E,8BAA8B,yBAAyB,EAAE;;IAEzD;IACA,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IACzB,0BAA0B;IAC1B,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,kBAAkB;EACpB;;EAEA,gBAAgB,gBAAgB,EAAE;;EAElC;IACE,cAAc;IACd,iBAAiB;EACnB","sourcesContent":["    .documentos p{margin-bottom: 0px;}\n    .main section{margin-top: 50px;}\n\n\n/* -----------------------------------------------------------------------------\n// LISTADO DE DOCUMENTOS EXISTENTES\n// ----------------------------------------------------------------------------- */\n    .documentos .listado-documentos{\n        width: 750px;\n        gap: 15px;\n    }\n\n    .documentos .listado-documentos .documento{\n        border: 1px solid #2A8C4A;\n        border-left: 12px solid #2A8C4A;\n        border-radius: 15px;\n        padding: 12px 30px 12px 20px;\n    }\n\n    .documentos .listado-documentos .iconos{ gap: 15px; }\n    .documentos .listado-documentos svg{ font-size: 18px; }\n\n\n/* -----------------------------------------------------------------------------\n// AREA verde + BOTÓN PARA SUBIR DOCUMENTOS\n// ----------------------------------------------------------------------------- */\n    .documentos .subir-documento{ width: calc(100% - 800px); }\n\n    .area-verde {\n    height: 150px;\n    max-width: 350px;\n    background-color: #c8e5b8;\n    border: 2px dashed #2A8C4A;\n    border-radius: 10px;\n    justify-content: center;\n    margin: 0 auto;\n    text-align: center;\n  }\n  \n  .area-verde p { margin: 0px 20px; }\n  \n  .documentos .subir-documento button {\n    display: block;\n    margin: 20px auto;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
